<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>


    <div v-show="!modoVisualizacao && !modoEdicao">
        <div class="form-edit-page" style="display: flex; gap: 10px; align-items: end;">
            <DateRangeSelect style="flex: 0 0 370px;" :periodoInicial="'currentMonth'" v-model="dateRange" ref="dateRangeSelect" />
            <div class="form-item flexible">
                <label class="label-caption">Pesquisar</label>
                <input type="text" v-model="termoPesquisa" maxlength="40" v-uppercase />
            </div>
            <KeepAlive>
                <div class="form-item flexible">
                    <EquipamentoGrupoSelect class="form-item" :ckAddTodos="true" v-model:idSelecionado="idGrupo" />
                </div>
            </KeepAlive>
            <div class="form-item flexible">
                <OsStatusSelect class="form-item" v-model:statusSelecionado="statusSelecionado" />
            </div>
            
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        <MensagemAlerta class="margin-top10" v-if="errorMessage" :mensagem="errorMessage" />
        
        <div v-if="lsDados.length>0" class="table-wrapper mt-sm">
            <table>
                <thead>
                    <tr>
                        <th>OS</th>
                        <th>Data</th>
                        <th>Horas</th>
                        <th>Nome</th>
                        <th>Localidade</th>
                        <th>Serviço</th>
                        <th>Situação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" @click="visualizarIpOS(obj)">
                        <td class="col-width-integer right">{{ obj.cdos }}</td>
                        <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtinclusao) }}</td>
                        <td class="col-width-date center">{{ Funcoes.formatTimeFromJson(obj.hrcontratadas) }}</td>
                        <td>{{ obj.nmpessoa }}</td>
                        <td>{{ obj.nmlocalidade }}</td>
                        <td>{{ obj.nmservico }}</td>
                        <td class="col-width-char20">{{ obj.nmsituacao }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />

            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>

            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoEdicao">
        <OsEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @save="lerDados" />
    </div>


    <div v-if="modoVisualizacao">
        <OSViewPage :idView="idView" @close="modoVisualizacao = false" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import OsEditPage from './OsEditPage.vue';
import OsStatusSelect from '@/selects/estaticos/OsStatusSelect.vue';
import OSViewPage from './OSViewPage.vue';

const emit= defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const errorMessage = ref(null);
const idEdicao = ref(0);
const idGrupo = ref(0);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const modoEdicao = ref(false);
const modoVisualizacao = ref(false);
const termoPesquisa = ref(null);
const showPagination = ref(false);
const statusSelecionado = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        errorMessage.value = null;
        isLoading.value = true;
        const termo             = termoPesquisa.value ? termoPesquisa.value.trim() : '';
        const parsedValue       = parseInt(termo, 10);
        const req = await genericPost('/os/vwos', {
            idmunicipio: globalStore.idmunicipio,
            idequipamentogrupo: idGrupo.value,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate,
            nmpesquisar: Number.isInteger(parsedValue) ? '' : termo,
            cdcadastro: Number.isInteger(parsedValue) ? parsedValue : 0,
            idossituacao: statusSelecionado.value});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

const novoCadastro = () => {
    idEdicao.value = 0;
    modoEdicao.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

const visualizarIpOS = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

onMounted(lerDados);
</script>
